import styled from 'styled-components';
import { Props } from '.';

export const Container = styled.div<Pick<Props, 'active'>>`
	width: 100vw;
	height: 100vh;
	background: rgba(40, 40, 53, 0.7);
	position: fixed;
	z-index: 100;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: ${({ active }) => (active ? 1 : 0)};
	transition: 0.3s;
	pointer-events: ${({ active }) => (active ? 'all' : 'none')};
`;

export const Content = styled.div<Pick<Props, 'active' | 'height' | 'maxHeight'>>`
	padding: 20px;
	margin: 0 20px;
	height: ${({ height }) => height ?? 'auto'};
	max-height: ${({ maxHeight }) => maxHeight};
	max-width: ${({ theme }) => theme.contentWidth};
	background-color: ${({ theme }) => theme.colors.bg1};
	overflow-y: auto;
	border-radius: 10px;
	transform: ${({ active }) => (active ? 'scale(1)' : 'scale(0.5)')};
	transition: 0.3s;
	position: relative;
`;

export const CloseIcon = styled.div<Pick<Props, 'active'>>`
	position: absolute;
	width: 37px;
	height: 37px;
	top: 0px;
	right: 20px;
	cursor: pointer;
	z-index: 1;
	transition: 0.3s;
	transform: ${({ active }) => (active ? 'scale(1)' : 'scale(0.1)')};
	opacity: ${({ active }) => (active ? 1 : 0)};

	& path {
		fill: ${({ theme }) => theme.colors.text5};
	}
`;

export const CloseImage = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
export const ContentContainer = styled.div`
	position: relative;
`;
